import { StaticChart } from "@quillsql/react"
import clsx from "clsx"

import { Card, Label } from "@atoms"

import styles from "./ReportChartCard.module.scss"
import { ReportChartCardProps } from "./ReportChartCard.types"

export default function ReportChartCard(props: ReportChartCardProps) {
    const { reportId, reportName, chartType, showLegend, onClick } = props

    const isMetric = chartType === "metric" || chartType === "number"
    const isTable = chartType === "table"

    return (
        <button type="button" className={clsx(styles.button, { [styles.tableButton]: isTable })} onClick={onClick}>
            <Card className={styles.card}>
                <Label label={reportName} variant="default" />
                <div className={clsx(styles.chart, { [styles.metricChart]: isMetric, [styles.tableChart]: isTable })}>
                    <StaticChart reportId={reportId} showLegend={showLegend} />
                </div>
            </Card>
        </button>
    )
}
